import PropTypes from "prop-types";
import "../assets/css/components.css";

export const FileUploader = ({
  name = "",
  type = "",
  placeholder = "",
  className = "",
  onChange = () => {},
  errorMsg,
  accept,
  multiple,
  isMandatory = true,
}) => {
  const inputProps = {
    name,
    type,
    className,
    onChange,
    accept,
    multiple,
  };

  return (
    <div className="wrapper">
      <label className="form-label">
        {placeholder}
        {isMandatory && <span className="mandatory-field">*</span>}
      </label>
      <input {...inputProps} className="field" onChange={onChange} />
      {errorMsg && <span className="error-message">{errorMsg}</span>}
    </div>
  );
};

FileUploader.propTypes = {
  name: PropTypes.string,
  type: PropTypes.any,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  errorMsg: PropTypes.any,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  isMandatory: PropTypes.bool,
};
